import { makeStyles } from "@material-ui/core";
import { white, backgroundColor } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  footerContainer: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    zIndex: 99,
  },
  formFooter: {
    background: backgroundColor,
    padding: "9px 18px 9px 18px",
    height: "55px",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  summary: {
    [down("sm")]: {
      "& p": {
        fontSize: "10px",
        fontFamily: "sbcBold",
      },
    },
  },
  flightDetails: {
    [down("xs")]: {
      display: "none",
    },
  },
  summaryTrigger: {
    height: "38px",
    width: "38px",
    border: `2px solid ${white}`,
    borderRadius: "55px",
    position: "relative",
  },
  counter: {
    height: "34px",
    width: "34px",
    backgroundColor: white,
    borderRadius: "55px",
  },
  pointer: {
    cursor: "pointer",
  },
  leftShape: {
    position: "absolute",
    left: 0,
    bottom: "98%",
  },
  rightShape: {
    position: "absolute",
    right: 0,
    bottom: "98%",
  },
}));

export default useStyles;
